module.exports = __webpack_public_path__ + "static/media/failedIcon.7f47a806.svg";